import { render, staticRenderFns } from "./StandsTable.vue?vue&type=template&id=bf7ad766&"
import script from "./StandsTable.vue?vue&type=script&lang=ts&"
export * from "./StandsTable.vue?vue&type=script&lang=ts&"
import style0 from "./StandsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VDataTable,VExpandXTransition})
